"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
exports.default = (function (props) { return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 775 775", className: classNames('sok-svg-icon', props.className) }),
    React.createElement("rect", { x: "154.9", y: "142.94", width: "480", height: "468", rx: "12", ry: "12", fill: "#fff", "data-name": "Layer 7" }),
    React.createElement("path", { d: "M387.5 0q104.68 0 193.75 52.35a391.61 391.61 0 0 1 141.41 141.4Q775 282.82 775 387.5t-52.34 193.75q-52.35 89.07-141.41 141.41T387.5 775q-104.69 0-193.75-52.34T52.34 581.25Q.01 492.2 0 387.5t52.34-193.75a391.61 391.61 0 0 1 141.41-141.4Q282.82 0 387.5 0zm181.25 425q18.75-10.93 18.75-32.81t-18.75-32.81l-275-167.19q-18.75-10.94-37.5 0T237.5 225v325q0 21.88 18.75 32.82t37.5 0z", fill: "#00c8ff", "data-name": "Layer 8" }))); });
//# sourceMappingURL=PlayCircle.js.map